// extracted by mini-css-extract-plugin
export default {"card":"styles_card__y+9SZ","cardIcon":"styles_cardIcon__RmeS3","shadowedIcon":"styles_shadowedIcon__Xw9Po","cardWithSpan":"styles_cardWithSpan__ZXkVi"};